const theme = {
  token: {
    colorPrimary: "#07C160",
  },
};

export default theme;